import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BVScCoursePage: React.FC = () => {
  const courseData = {
    title: "BVSc & AH - Bachelor of Veterinary Science & Animal Husbandry",
    shortName: "BVSc & AH",
    duration: "5.5 years (4.5 years + 1 year internship)",
    description: "Comprehensive veterinary medicine focusing on animal health, welfare, and livestock management",
    overview: "Bachelor of Veterinary Science & Animal Husbandry (BVSc & AH) is an undergraduate professional degree that trains students to become veterinarians. This course covers animal anatomy, physiology, pathology, pharmacology, surgery, and preventive medicine, preparing graduates to diagnose, treat, and prevent diseases in animals while also focusing on animal welfare and livestock management.",
    eligibility: [
      "10+2 with Physics, Chemistry, Biology",
      "Minimum 50% marks (40% for SC/ST)",
      "NEET qualification mandatory",
      "Age: 17-25 years"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Veterinary Anatomy",
          "Veterinary Physiology",
          "Animal Biochemistry",
          "Veterinary Histology",
          "Animal Genetics",
          "Biostatistics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Veterinary Pathology",
          "Veterinary Microbiology",
          "Veterinary Parasitology",
          "Veterinary Pharmacology",
          "Animal Nutrition",
          "Livestock Production Management"
        ]
      },
      {
        year: 3,
        subjects: [
          "Veterinary Medicine",
          "Veterinary Surgery",
          "Veterinary Obstetrics & Gynecology",
          "Veterinary Public Health",
          "Poultry Science",
          "Animal Breeding"
        ]
      },
      {
        year: 4,
        subjects: [
          "Clinical Veterinary Medicine",
          "Veterinary Epidemiology",
          "Veterinary Extension",
          "Meat Hygiene & Technology",
          "Veterinary Jurisprudence",
          "Wildlife Health & Management"
        ]
      },
      {
        year: 5,
        subjects: [
          "Clinical Training",
          "Internship in Veterinary Hospitals",
          "Field Veterinary Practice",
          "Research Project",
          "Dairy Technology",
          "Veterinary Business Management"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Veterinary Doctor",
        "Livestock Development Officer",
        "Veterinary Officer (Government)",
        "Animal Husbandry Officer",
        "Research Scientist",
        "Veterinary Consultant",
        "Pet Clinic Owner",
        "Wildlife Veterinarian",
        "Dairy Farm Manager",
        "Veterinary Drug Inspector"
      ],
      industries: [
        "Government Veterinary Departments",
        "Private Veterinary Clinics",
        "Dairy Industry",
        "Pharmaceutical Companies",
        "Research Institutions",
        "Zoo & Wildlife Sanctuaries",
        "Pet Care Industry",
        "Livestock Farms",
        "Food Processing Industry",
        "International Organizations"
      ],
      averageSalary: "₹3.5-10 LPA",
      topRecruiters: [
        "State Animal Husbandry Departments",
        "Indian Veterinary Research Institute",
        "Pharmaceutical Companies",
        "Dairy Cooperatives",
        "Pet Care Companies",
        "International Development Organizations"
      ]
    },

    topColleges: [
      {
        name: "Indian Veterinary Research Institute",
        location: "Bareilly, Uttar Pradesh",
        fees: "₹35,000/year",
        ranking: "9.5/10"
      },
      {
        name: "Madras Veterinary College",
        location: "Chennai, Tamil Nadu",
        fees: "₹25,000/year",
        ranking: "9.2/10"
      },
      {
        name: "College of Veterinary Science",
        location: "Hyderabad, Telangana",
        fees: "₹40,000/year",
        ranking: "9.0/10"
      },
      {
        name: "Veterinary College & Research Institute",
        location: "Namakkal, Tamil Nadu",
        fees: "₹30,000/year",
        ranking: "8.8/10"
      },
      {
        name: "Kerala Veterinary & Animal Sciences University",
        location: "Thrissur, Kerala",
        fees: "₹35,000/year",
        ranking: "8.6/10"
      }
    ],

    skills: [
      "Animal Diagnosis & Treatment",
      "Surgical Procedures",
      "Animal Handling & Restraint",
      "Laboratory Diagnostics",
      "Preventive Medicine",
      "Animal Welfare Assessment",
      "Livestock Management",
      "Emergency Veterinary Care",
      "Research & Data Analysis",
      "Client Communication"
    ],

    futureScope: "Growing pet industry, increasing focus on animal welfare, expansion of dairy and livestock industry, wildlife conservation efforts, food safety regulations, zoonotic disease management, biotechnology applications in veterinary medicine, international career opportunities, and growing demand for specialized veterinary services.",

    faqs: [
      {
        question: "Is BVSc & AH equivalent to MBBS for animals?",
        answer: "Yes, BVSc & AH is considered the equivalent of MBBS for animals and is a professional medical degree for treating animals."
      },
      {
        question: "Can veterinarians treat human patients?",
        answer: "No, veterinarians are specifically trained and licensed to treat animals only. They cannot legally treat human patients."
      },
      {
        question: "What is the scope of veterinary medicine in India?",
        answer: "India has a large livestock population and growing pet industry, offering excellent opportunities in government sectors, private practice, and industry."
      },
      {
        question: "Is NEET required for BVSc & AH admission?",
        answer: "Yes, NEET is mandatory for admission to BVSc & AH courses in all veterinary colleges across India."
      },
      {
        question: "Can I specialize after BVSc & AH?",
        answer: "Yes, you can pursue MVSc (Master of Veterinary Science) or PhD in various specializations like surgery, medicine, pathology, etc."
      },
      {
        question: "What are the job prospects in government sector?",
        answer: "Government offers positions like Veterinary Officer, Livestock Development Officer, and roles in research institutes with good job security and benefits."
      }
    ],

    admissionProcess: [
      "NEET Qualification",
      "State/National Counseling Registration",
      "Choice Filling & Document Verification",
      "Seat Allotment",
      "College Reporting & Fee Payment"
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BVScCoursePage;
